import React, { FC } from "react";

import { useRichText } from "~/hooks/useRichText";
import { useRouteLoaderData } from "~/hooks/useRouteLoaderData";

import type { ComponentProps, FromSanityGraphQL } from "~/types/components";
import { type SectionCollectionHeroBanner } from "~/types/sanity";

type CollectionHeroBannerInputProps = ComponentProps &
  FromSanityGraphQL<SectionCollectionHeroBanner> & {
    collectionTitle: string;
  };

export type CollectionHeroBannerOutputProps = CollectionHeroBannerInputProps & {
  enableNosto: boolean;
};

export const withCollectionHeroBanner =
  (Component: FC<CollectionHeroBannerOutputProps>) =>
  ({
    name = "CollectionHeroBanner",
    collectionTitle,
    desktopBanner,
    location,
    mobileBanner,
    ...props
  }: CollectionHeroBannerInputProps) => {
    const { enableNosto } = useRouteLoaderData("routes/$site");
    const { parseContent } = useRichText();

    const desktop = parseContent(desktopBanner);
    const mobile = parseContent(mobileBanner);

    return (
      <Component
        collectionTitle={collectionTitle}
        desktopBanner={desktop}
        mobileBanner={mobile}
        location={location}
        enableNosto={enableNosto}
        {...props}
      />
    );
  };
